export const COMMAND_CHAIN_STARTED = 'OperationChainStarted';
export const COMMAND_CHAIN_COMPLETED = 'europa.framework.scheduler.OperationChainCompleted';
